import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NotificationState, getNotificationCounts, getUnReadNotifications, markNotificationsAsRead } from "../../redux/notification-slice";
import { AppState } from "../../redux/store";
import { parseISO } from "date-fns";
import { FabrixNotification, NotificationCard, NotificationCardProps } from "./notification-card";
import { useDataController } from "../../hooks";
import { ClientUserService } from "../../services";
import { ProgressBar } from "primereact/progressbar";
import { NTNotification } from "@nt-portal/server-sdk";



/**
 * Displays unread notifications within an overlay, fetching sender details and marking them as read.
 * @returns Notification panel listing current unread notifications.
 */
export default function NotificationPanel() {


    const dispatch = useDispatch<any>();
    const _notState = useSelector<AppState>(state => state.notifications) as NotificationState;
    const [_users, _usersTotal, _usersBusy, usersActions] = useDataController(new ClientUserService())

    const [_notifications, setNotifications] = useState<FabrixNotification[]>([])
    const ref = useRef<HTMLDivElement>(null);
    const [_height, setHeight] = useState<number>(300)
    const [_width, setWidth] = useState<number>(300)

    useEffect(() => {
        dispatch(getUnReadNotifications(""))
        if (ref.current) {
            let element = document.getElementById("note_overlay_panel");
            if (element) {
                setHeight(element.clientHeight - 10);
                setWidth(element.clientWidth - 30)

            }
        }

    }, []);


    /**
     * Marks notifications as read when they have not been acknowledged.
     * @param unread Collection of unread notifications.
     */
    const markAsUnread = (unread: NTNotification[]) => {
        let ids = unread.filter(x => !x.read && x.id !== undefined).map(x => x.id ?? '');
        if (ids.length > 0) {
            dispatch(markNotificationsAsRead(ids));
        }
    }

    /**
     * Retrieves cached user details for a notification sender.
     * @param id User identifier.
     * @returns Matching user record when available.
     */
    const getUser = async (id: string) => {
        let user = _users.find(x => x.id === id)
        return user;
    }

    /**
     * Enriches raw notifications with display metadata and ensures sender info is loaded.
     * @param data Raw notification records.
     * @returns Array of notifications ready for display.
     */
    const buildData = async (data: NTNotification[]) => {
        let nots = new Array<FabrixNotification>();
        let size = data.length;


        let sendBy = data.map(x => x.sentBy);
        let sentSet = new Set<string>(sendBy);
        let sentArray = Array.from(sentSet)
        for (let i = 0; i < sentArray.length; i++) {
            const id = sentArray[i];
            await usersActions.getById({ id: id })
        }

        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            let note = { ...item } as FabrixNotification;
            if (typeof note.timeStamp === 'string')
                note.timeStamp = parseISO(note.timeStamp)
            let user = await getUser(note.sentBy)
            if (user)
                note.sendByDisplay = ClientUserService.displayName(user)
            nots.push(note);
            markAsUnread(nots);
        }

        return nots;

    }

    useEffect(() => {
        let data = _notState.unread;

        buildData(data).then(nots => {
            setNotifications(nots);
        })

    }, [_notState.unread])

    /**
     * Wraps a notification in a card component.
     * @param value Notification to render.
     * @returns Notification card element.
     */
    const renderCard = (value: FabrixNotification) => {

        let props: NotificationCardProps = {
            notification: value
        }
        return (<NotificationCard {...props} />);

    }

    let style: React.CSSProperties = {
        maxHeight: _height,
        overflowX: 'hidden',
        overflowY: 'auto'
        // width: _width

    }

    return (

        <div ref={ref} style={style} >
            {
                _notifications.map((value, index) => {
                    return (
                        <div key={index}>
                            {renderCard(value)}
                        </div>
                    )
                })
            }
        </div>

    )
}


